import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {RoleModel} from '@/libs/Api';
import {RolesDataService} from '@/libs/roles/roles-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const rolesStore = registerCrudStore<RoleModel, RoleModel>(BusinessModule.Role, new RolesDataService());
